import { render, staticRenderFns } from "./comment-step.vue?vue&type=template&id=001f9df6&"
import script from "./comment-step.vue?vue&type=script&lang=js&"
export * from "./comment-step.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports